import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  private apiUrl = 'https://be.festivalsousse.com/api/media';

  constructor(private http: HttpClient) { }

  uploadImage(fichier: File): Observable<{ success: boolean; url?: string; nom?: string; message?: string }> {
    const formData = new FormData();
    formData.append('fichier', fichier);
    return this.http.post<{ success: boolean; url: string; nom: string }>(`${this.apiUrl}/upload`, formData);
  }

  // Mediatheque persistante : liste de tous les fichiers deja importes sur le serveur
  liste(): Observable<{ nom: string; url: string; taille: number; date: string }[]> {
    return this.http.get<{ nom: string; url: string; taille: number; date: string }[]>(`${this.apiUrl}/liste`);
  }

  // Genere une image IA cote serveur (Pollinations.ai) : evite les soucis de CORS / canvas
  // "souille" que l'on aurait en appelant l'API directement depuis le navigateur.
  genererImageIA(prompt: string): Observable<{ success: boolean; url?: string; nom?: string; erreur?: string }> {
    return this.http.get<{ success: boolean; url?: string; nom?: string; erreur?: string }>(
      `${this.apiUrl}/generer-ia`, { params: { prompt } }
    );
  }

  supprimer(nomFichier: string): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`${this.apiUrl}/${nomFichier}`);
  }
}
